import { Label } from "shared/ui-basics/index";
import { widthValidation } from "@utils/helpers";
import { Col } from "react-bootstrap";
import Moment from "react-moment";
import { DropdownToggle } from "reactstrap";
import styled from "styled-components/macro";

export const CustomerFeedbackContainer = styled.div`
	width: ${(props) => widthValidation(props.width)}px;
	margin-right: 8px;
	#fbData {
		visibility: hidden;
	}
	:hover #fbData {
		visibility: visible;
	}
`;
export const CustomerFeedbackHeaderWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items:center;
	width:100%;
`;
export const CustomerFeedbackCardWrapper = styled.div`
	padding: 1rem;
	min-height: 112px;
	border-radius: 4px;
	border:${props => props.open ? '1px solid #333333':'1px solid #efefef'};
	position: relative;
	:hover .drop-actions {
		visibility: visible;
	}
    :hover {
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.15);
	}
`;
export const CustomerFeedbackBodyWrapper = styled.div`
	cursor: pointer;
	display: flex;
	padding-top:1rem;
`;
export const IconPosition = styled.div`
	position: relative;
	top: 0px;
	right: 12px;
	z-index: 3;
	width: 1px;
`;
export const TouchPointImage = styled.img`
	width: 18px;
	height: 18px;
	/* margin-left: 8px; */
	margin-right: 8px;
`;

export const ImgWrapper = styled.img`
	height: 20px;
`;

export const LabelWrapper = styled(Label)`
	/* font-style: italic; */
	/* color:#C4C4C4; */
	font-size: 12px;
`;
export const LabelNonData = styled(Label)`
	color: #333333;
	${(props) => props.isbold === "true" && `font-weight:600;`};
`;
export const MomentWrapper = styled(Moment)`
	font-size: 12px;
	/* font-style: italic; */
	color: #262626;
	line-height: 12px;
`;
export const ColTextEnd = styled(Col)`
	text-align: end;
`;
export const DivWrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	path {
		fill: #c4c4c4;
	}
	svg {
		height: 32px;
	}
`;
export const Actions = styled.div`
	#showIcon {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: start;
	}
	.drop-actions {
		visibility: hidden;
	}

`;
export const WrapperDropdownToggle = styled(DropdownToggle)`
	height: 36px;
	background-color: transparent !important;
	color: #605f60 !important;
	font-size: 14px;
	:hover {
		color: #605f60 !important;
		background-color: #efefef !important;
	}
`;
export const Logo = styled.div`
	width: 24px;
	height: 24px;
	border: 1px solid #262626;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
    background-color: ${({color}) => color};
`;